// @flow
import * as React from 'react';
import saga from './ugcAssignmentSaga';
import reducer from './ugcAssignmentReducer';
import { injectSaga, injectReducer } from 'store';
import Context, {
  type UgcAssignmentContextShape as ContextShape,
} from './UgcAssignmentContext';
import { connect } from 'react-redux';
import {
  requestAssignment,
  type AssignmentState,
} from './ugcAssignmentReducer';

const REDUCER_NAME = 'ugcAssignment';
injectSaga(saga);
injectReducer({ [REDUCER_NAME]: reducer });

export const UgcAssignmentContext = Context;

type StateProps = {
  ugcAssignment: AssignmentState,
};
type OwnProps = {
  children: React.Node,
};
type DispatchProps = {
  requestAssignment: Function,
};

type Props = StateProps & DispatchProps & OwnProps;

class UgcAssignmentProvider extends React.Component<Props, ContextShape> {
  state = {};

  static getDerivedStateFromProps(nextProps) {
    return {
      assignments: nextProps.ugcAssignment,
      requestAssignment: nextProps.requestAssignment,
    };
  }

  render() {
    if (!this.state) return null;

    return (
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  ugcAssignment: state[REDUCER_NAME],
});

export default connect(mapStateToProps, { requestAssignment })(
  UgcAssignmentProvider
);



// WEBPACK FOOTER //
// ./src/containers/client/UgcAssignmentProvider.js